import { render } from "./EventParticipationsMonitor.vue?vue&type=template&id=0c3e04fc&ts=true"
import script from "./EventParticipationsMonitor.vue?vue&type=script&lang=ts"
export * from "./EventParticipationsMonitor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__